import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DocumentiService } from 'src/app/core/documenti.service';
import { Versamento } from 'src/app/shared/models/versamento.model';

@Component({
  selector: 'app-state-archive-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Versamento agli archivi di stato" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()">
    <label for="numeroNota" class="small-label">Numero Nota/Verbale</label>
    <textarea pInputTextarea id="numeronota" [rows]="3" [cols]="30" [(ngModel)]="numeroNota"></textarea>
    <label for="dal" class="small-label">Del</label>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="date"
      [inputStyle]="{'width': '187px'}">
    </p-calendar>
    <label for="note" class="small-label">Note</label>
    <textarea pInputTextarea id="note" [rows]="5" [cols]="30" [(ngModel)]="note"></textarea>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" class="p-button-primary" icon="fas fa-fw fa-landmark" label="Versa" (click)="send_click()"
        [disabled]="!date || !numeroNota"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  `]
})

export class StateArchiveDialogComponent {
  visible = model.required<boolean>();
  documentId = input<number | undefined>();

  hide = output();
  done = output<Versamento>();
  fail = output<HttpErrorResponse>();

  public date: Date | null = null;
  public note = '';
  public numeroNota = '';

  private confirmationService = inject(ConfirmationService);
  private documentiService = inject(DocumentiService);

  hideDialog(): void {
    this.date = null;
    this.note = '';
    this.numeroNota = '';
    this.hide.emit();
  }

  send_click(): void {
    const documentId = this.documentId();
    if (!documentId || documentId < 0 || !this.date) return;

    const request: Versamento = {
      date: this.date,
      note: this.note,
      numeroNota: this.numeroNota
    };

    this.confirmationService.confirm({
      header: 'Versamento documento agli archivi di stato',
      message: `<strong>Versare</strong> il documento agli archivi di stato?
      <p>Il versamento del documento è un processo <strong>IRREVERSIBILE</strong> che eliminerà tutti gli allegati e impedirà ogni ulteriore modifica.</p>`,
      acceptLabel: 'Versa',
      icon: 'fas fa-fw fa-landmark',
      accept: () => {
        this.documentiService.sendToStateArchive(documentId, request).subscribe({
          next: () => {
            this.done.emit(request);
            this.hideDialog();
          },
          error: (error: HttpErrorResponse) => {
            this.fail.emit(error);
          }
        });
      }
    });
  }
}
